<template>
  <el-main>
    <ContentNav
      :bannerTextIMG="require('../assets/Introduce/bannerText.png')"
      :bannerimgIMG="Url.imgUrl + this.$store.state.NavList[1].banner"
    ></ContentNav>
    <div class="content">
      <div class="container">
        <Menu :Menulist="{MenuList}" @changeNavIndex = "changeModule"></Menu>
        <!-- 盈科深圳简介 -->
        <div  v-if="MenuListChecked==0 " class="con-intde">
          <div class="title">北京市盈科（深圳）律师事务所</div>
          <div class="content" v-html="Introduce"></div>
        </div>
        <!-- 律所环境 -->
        <div  v-if="MenuListChecked==1" class="environment">
          <div class="menuContent">
            <div class="item"  v-for="(x,i) in OfficeArea" :key="i">
              <div class="title" >{{x.name}}</div>
              <div class="item-box" >
                <div class="item-box-option" v-for="(j,l) in x.picuteList" :key="l">
                  <img :src="Url.imgUrl+j.url" :alt="SystemOption.seoKeyWord" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 荣誉奖项 -->
       <div class="award" v-if="MenuListChecked==2">
          <div class="timeline">
            <div class="timeline-item" v-for="(x,i) in AwardsDate" :key="i" @click="AdsDateCd(i)">
              <div :class="AwardsDateCd==i ? 'act time':'time'">{{x}}</div>
              <span class="dian"></span>
            </div>
            <div class="timeline-item" @click="lastAdsDateCd()">
              <div :class="{'time':true,'act':isLastAwardsIndex}">过往荣誉</div>
              <span class="dian"></span>
            </div>
          </div>
          <div class="award-item" v-for="(item,index) in awardsList" :key="index">
            <div class="award-item-img">
              <img :src="Url.imgUrl+item.coverImg" alt="" />
            </div>
            <div class="award-item-text">
              <div class="title">{{item.title}}</div>
              <div v-html="item.intro"></div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <Icongroup></Icongroup>
  </el-main>
</template>

<script>
// import func from '../../vue-temp/vue-editor-bridge'
import ContentNav from "../components/ContentNav";
import Menu from "../components/Menu";
import Icongroup from "../components/Icon_group"; 
export default {
  components: {
    ContentNav,
    Menu,
    Icongroup
  },
  data() {
    return {
      MenuListChecked:0,
      MenuList: [{
						id: 0,
						name: "盈科深圳",
						route: {path:"/introduce/yksz.html"}
					},
					{
						id: 1,
						name: "律所环境",
						route: {path:"/introduce/lshj.html"}
					},
					{
						id: 2,
						name: "荣誉奖项",
						route: {path:"/introduce/ryjx.html"}
					},
				],
      AwardsDate:[2020,2019,2018],
      AwardsDateCd:1,
      Introduce: "暂无内容", //盈科介绍
      OfficeArea:"暂无内容", //律所环境
      Awards:"暂无内容", //荣誉奖项
      SystemOption:[] ,//SEO 配置
      sidebarName: "荣誉奖项",
      navCheckedIndex: 2,
      isLastAwardsIndex: false,
      awardsList: [], //荣誉奖项
      isShowWXrcode: false, //是否悬浮显示微信二维码

    };
  },
  metaInfo() {
			return {
				title: `盈科介绍-${this.SystemOption.seoTitle ?? ''}`,
				meta: [{ // set meta
					name: 'keywords',
					content: this.SystemOption.seoKeyWord
				},{ // set meta
					name: 'description',
					content: this.SystemOption.seoDescribe
				}]
			}
		},
  methods:{
     //滚动监听方法
    handleScroll() {
      window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop > 500 ? (this.isDisFloat = true) : (this.isDisFloat = false);
    },
			AdsDateCd(i) {
				console.log(i)
				let that = this;
				that.AwardsDateCd = i;
				that.isLastAwardsIndex = false;
				//获取荣誉奖项
				that.axios({
					type: "get",
					url: that.Url.apiUrl + "Introduce/GetAward",
					params: {
						dateYear: that.AwardsDate[i]
					}
				}).then((res) => {
					console.log(res.data)
					that.awardsList = res.data;
				});
      },
    
    //显示隐藏模块
    changeModule(num,v){
      console.log(num,v)
      this.MenuListChecked = num;
    },
      lastAdsDateCd() {
				let that = this;
				that.AwardsDateCd = -1;
				that.isLastAwardsIndex = true;
				//获取荣誉奖项
				that.axios({
					type: "get",
					url: that.Url.apiUrl + "Introduce/GetAward",
					params: {
						dateYear: that.AwardsDate[2],
						isOld: true
					}
				}).then((res) => {
					that.awardsList = res.data;
				});
			},


  },
  beforeCreate(){
     
  },
  created() {
    //添加滚动监听
			window.addEventListener('scroll',this.handleScroll)
    //初始化路径数据
    this.$store.state.Currentposition = [ {path:'/',name:'首页'},{path:'/introduce/yksz.html',name:'盈科介绍'} ]
    //获取盈科介绍
    this.axios({ type: "get", url: this.Url.apiUrl + "Introduce/GetIntroduce"}).then((res) => { this.Introduce = res.data.contents; });
    //获取律所区域
    this.axios({ type: "get", url: this.Url.apiUrl + "Introduce/GetOfficeArea"}).then((res) => { this.OfficeArea = res.data; });
    //获取荣誉奖项
    // this.axios({ type: "get", url: this.Url.apiUrl + "Introduce/GetAward",params:{dateTime:'2020'}}).then((res) => { this.Awards = res.data; });
    //获取荣誉奖项
    this.AdsDateCd(0);
    //获取SEO配置
    this.axios.get(this.Url.apiUrl+"SystemOption/GetSystemOption").then(res => this.SystemOption = res.data);
  },
};
</script>

<style lang="scss" scoped>
.el-main {
  .content {
    position: relative;
    width: 100%;
    min-height: 600px;
    .container {
      position: relative;
      width: 1200px;
      display: flex;
      margin: 0 auto;
      @media screen and (max-width: 768px) {
        width: 100%;
        display: block;
        padding: 26px 21px;
        overflow: hidden;
      }
      .environment {
        position: relative;
        .menuContent {
          flex: 0 0 1000px;
          width: 1000px;
          padding: 40px 0 40px 30px;
          @media screen and (max-width: 768px) {
            width: 100%;
            padding: 20px 0 20px 0;
          }
          .item {
            position: relative;
            height: 185px;
            margin: 20px 0;
            @media screen and (max-width: 768px) {
              height: 225px;
              overflow: hidden;
            }
            .title {
              display: block;
              width: auto;
              color: #999999;
              font-weight: 600;
              @media screen and (max-width: 768px) {
                font-size: 15px;
              }
            }
            .title::before {
              display: inline-block;
              width: 3px;
              height: 15px;
              background-color: #be9d6d;
              content: "";
              margin-right: 18px;
              @media screen and (max-width: 768px) {
                width: 3px;
                height: 15px;
                position: relative;
                top: 2px;
              }
            }
            .item-box {
              display: flex;
              align-items: center;
              // justify-content: space-between;
              margin-top: 16px;
              width: 100%;
              // flex-wrap: nowrap;
              overflow: hidden;
              @media screen and (max-width: 768px) {
                flex-wrap: wrap;
                justify-content: space-between;
              }
              .item-box-option {
                flex: 0 0 22%;
                width: 230px;
                height: 140px;
                overflow: hidden;
                border-radius: 5px;
                margin: 0 16px;
                @media screen and (max-width: 768px) {
                  flex: 0 0 146px;
                  height: 96px;
                  overflow: hidden;
                  margin: 0;
                }
                img {
                  width: 100%;
                  height: auto;
                }
              }
            }
          }
        }
      }
      .con-intde {
        position: relative;
        display: block;
        flex: 0 0 1000px;
        width: 1000px;
        padding: 40px 0 40px 30px;
        @media screen and (max-width: 768px) {
          width: 100%;
          padding: 20px 0 20px 0;
        }
        .title {
          color: #7a7a7a;
          font-weight: 600;
          font-size: 18px;
          text-align: center;
          line-height: 50px;
          @media screen and (max-width: 768px) {
            width: 100%;
            font-weight: 500;
            line-height: 55px;
            font-size: 15px;
          }
        }
        .content {
          color: #7a7a7a;
          text-indent: 20px;
          line-height: 32px;
          font-size: 15px;
          @media screen and(max-width:768px) {
            color: #b1b1b1;
            font-size: 13px;
            line-height: 20px;
          }
        }
      }
      .award {
        position: relative;
        display: block;
        flex: 0 0 1000px;
        width: 1000px;
        padding: 40px 0 120px 30px;
        @media screen and(max-width: 768px) {
          width: 100%;
          padding: 20px 0 20px 0px;
        }
        .timeline {
          width: 100%;
          display: flex;
          justify-content: center;
          margin-bottom: 50px;
          @media screen and(max-width: 768px) {
            display: none;
          }
          .timeline-item {
            flex: 0 0 25%;
            position: relative;
            .time {
              width: 50px;
              height: 50px;
              border-radius: 50%;
              border: 1px solid #d0a971;
              display: flex;
              justify-content: center;
              align-items: center;
              color: #d0a971;
              position: relative;
              font-size: 12px;
              padding: 10px;
              text-align: center;
              cursor: pointer;
            }
            .dian::after {
              width: 5px;
              height: 5px;
              background-color: #d0a971;
              border-radius: 50%;
              content: "";
              display: block;
              position: absolute;
              left: 55px;
              top: 23px;
            }
            .time::before {
              width: 10rem;
              display: block;
              border-bottom: 1px dashed #d0a971;
              position: absolute;
              left: 60px;
              content: "";
            }
            .act {
              color: #fff;
            }
            .act::after {
              display: block;
              position: absolute;
              background-color: #d0a971;
              content: "";
              width: 40px;
              height: 40px;
              border-radius: 50%;
              z-index: -1;
            }
          }
          .timeline-item:last-of-type {
            flex: 0 0 auto;
            .time::before {
              content: none;
            }
            .dian::after {
              content: none;
            }
          }
        }
        .award-item {
          width: 100%;
          position: relative;
          display: flex;
          justify-content: flex-start;
          border-bottom: 1px dashed #d8d8d8;
          margin: 20px 0;
          padding: 10px 0;
          .award-item-img {
            flex: 0 0 150px;
            width: 150px;
            overflow: hidden;
            margin-right: 40px;
            @media screen and(max-width: 768px) {
              flex: 0 0 90px;
              width: 90px;
            }
            img {
              width: 150px;
              height: auto;
              @media screen and(max-width: 768px) {
                width: 100%;
                height: auto;
              }
            }
          }
          .award-item-text {
            color: #888;
            font-size: 14px;
            .title {
              color: #000;
              font-size: 15px;
              font-weight: 600;
              margin-bottom: 10px;
            }
          }
        }
        .award-item:last-of-type {
          border: none;
        }
      }
    }
  }
}
</style>